import { globalStyles } from "@client/shared/constants";
const { display, flex, background } = globalStyles;
const style = {
  drawerPaper: {
    height: "100%",
    width: "250px",
  },
  nameWrapper: {
    padding: "12px 14px",
    marginBottom: "16px",
    backgroundColor: "primary.dark",
    ...display.flex,
  },
  icon: {
    color: "black",
    ...flex.justify.end,
  },
  role: {
    fontSize: "12px",
  },
  userData: {
    marginLeft: "18px",
    color: "white",
  },
  appBar: {
    // zIndex: (theme) => theme.zIndex.drawer + 2,
    position: "fixed",
    backgroundColor: "grey.100",
    border: "0.5px solid rgb(223,223,223)",
  },
};

export default style;
